import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../VehicleForm';

interface FuelConsumptionGroupProps {
  fuelSuffix?: string;
}

export function FuelConsumptionGroup(props: FuelConsumptionGroupProps) {
  const fuelSuffix = props.fuelSuffix ?? i18n.t('general.metric.l100km');
  return (
    <>
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionCombined"
        suffix={fuelSuffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionUrban"
        suffix={fuelSuffix}
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="fuelConsumptionExtraUrban"
        suffix={fuelSuffix}
      />
    </>
  );
}
